<ng-container>
  <div class="tab-toolbar">
    <button class="um-btn" [disabled]="!selectedUser" (click)="approveUser()">
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.4"/>
        <path d="M5 8l2 2 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Approve
    </button>
  </div>
  <wc-grid #rejectedGrid gridKey="rejectedUsers" [reloadUserOnSave]="true"
           [showQuickSearch]="true" searchPlaceholder="Search users..."
           (selectedRowChange)="onUserSelected($event)" />
</ng-container>
